import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
  Chart,
  Geom,
  Axis,
  Tooltip,
  Legend} from 'bizcharts'
const CommoditySalesTrend = (props) => {
  const cols = {
    date: {
      range: [0, 1]
    },
    value: {
      min: 0
    }
  }

  const handleJump = (e) => {
    const Url = `${'/main/salesreport/salesstatisticsreport/salesstatisticsreport?nameCode='}${e.data.type}${'&&particle='}${props.particle}${'&&jumpdata='}${e.data.date}`
    return Url
  }

  return (
    <Chart height={props.commodityData.length !== 0 ? 400 : 0} data={props.commodityData} scale={cols} autoFit>
      <Legend marker={{
        symbol: (x, y, radius) => {
          const r = radius / 2
          return [
            ['M', x - radius, y],
            ['A', r, r, 0, 0, 1, x, y],
            ['A', r, r, 0, 0, 0, x + radius, y]
          ]
        },
        style: {
          fill: ''
        }
      }} />
      <Axis name="date" />
      <Axis
        name="value"
        label={{
          formatter: val => `${val}`
        }}
      />

      <Tooltip
        shared={true}
        lock
        enterable
        showCrosshairs
        style={{
          color: 'red'
        }}
      >
        {
          (title, items) => {
            return <div style={{ padding: 10 }}>
              {title}
              <div>
                {
                  items.map(it => {
                  // console.log(it) // 这里可以获取颜色等信息
                    return <div style={{margin: '8px 8px'}}><span><span style={{ display: 'inline-block', width: '10px', height: '10px', borderRadius: '50%', background: it.color, marginRight: '8px' }}></span><span >{it.data.type + '：'}</span></span><a href={handleJump(it)} target="_blank">{it.data.value}</a></div>
                  })
                }
              </div>
            </div>
          }
        }
      </Tooltip>

      <Geom
        type="line"
        position="date*value"
        size={2}
        color={'type'}
      />
      <Geom
        type="point"
        position="date*value"
        size={0}
        shape={'circle'}
        color={'type'}
        style={{
          stroke: '#fff',
          lineWidth: 1
        }}
        // tooltip = {['date*']}
      />
    </Chart>
  )
}
export default CommoditySalesTrend



// WEBPACK FOOTER //
// ./src/pages/salesreport/salesoverview/commoditychart.js